import React from 'react';
import { Section } from './ui/Section';
import { Sun, Moon, Utensils } from 'lucide-react';
export function MechanismReveal() {
  return <Section background="cream" id="mechanism" data-id="element-33">
      <div className="text-center mb-16" data-id="element-34">
        <span className="uppercase tracking-widest text-[#8B9D83] font-bold text-sm" data-id="element-35">
          El Mecanismo Único
        </span>
        <h2 className="text-4xl font-bold text-[#2C2C2C] mt-4 mb-6" data-id="element-36">
          Sistema 10–10–10
        </h2>
        <p className="text-xl text-[#5A5A5A] max-w-2xl mx-auto" data-id="element-37">
          Menopausia Sin Caos te da un plan diario de 30 minutos total.
        </p>
      </div>

      <div className="space-y-6" data-id="element-38">
        {/* 10 AM */}
        <div className="bg-white p-8 rounded-2xl shadow-sm flex flex-col md:flex-row items-center gap-6 border-l-8 border-[#D4735E]" data-id="element-39">
          <div className="bg-[#FFF8F0] p-4 rounded-full" data-id="element-40">
            <Sun className="h-8 w-8 text-[#D4735E]" data-id="element-41" />
          </div>
          <div className="text-center md:text-left" data-id="element-42">
            <h3 className="text-2xl font-bold text-[#2C2C2C] mb-2" data-id="element-43">
              10 AM{' '}
              <span className="text-base font-normal text-[#5A5A5A]" data-id="element-44">
                (Cortisol)
              </span>
            </h3>
            <p className="text-[#5A5A5A]" data-id="element-45">
              10 minutos para bajar la alarma interna y empezar el día estable.
            </p>
          </div>
        </div>

        {/* 10 FOOD */}
        <div className="bg-white p-8 rounded-2xl shadow-sm flex flex-col md:flex-row items-center gap-6 border-l-8 border-[#8B9D83]" data-id="element-46">
          <div className="bg-[#F4F6F3] p-4 rounded-full" data-id="element-47">
            <Utensils className="h-8 w-8 text-[#8B9D83]" data-id="element-48" />
          </div>
          <div className="text-center md:text-left" data-id="element-49">
            <h3 className="text-2xl font-bold text-[#2C2C2C] mb-2" data-id="element-50">
              10 FOOD{' '}
              <span className="text-base font-normal text-[#5A5A5A]" data-id="element-51">
                (Inflamación)
              </span>
            </h3>
            <p className="text-[#5A5A5A]" data-id="element-52">
              Un plato mediterráneo simple, sin recetas raras ni ingredientes
              imposibles.
            </p>
          </div>
        </div>

        {/* 10 PM */}
        <div className="bg-white p-8 rounded-2xl shadow-sm flex flex-col md:flex-row items-center gap-6 border-l-8 border-[#2C2C2C]" data-id="element-53">
          <div className="bg-[#E8E8E8] p-4 rounded-full" data-id="element-54">
            <Moon className="h-8 w-8 text-[#2C2C2C]" data-id="element-55" />
          </div>
          <div className="text-center md:text-left" data-id="element-56">
            <h3 className="text-2xl font-bold text-[#2C2C2C] mb-2" data-id="element-57">
              10 PM{' '}
              <span className="text-base font-normal text-[#5A5A5A]" data-id="element-58">
                (Sueño/Glucosa)
              </span>
            </h3>
            <p className="text-[#5A5A5A]" data-id="element-59">
              Rutina corta para apagar el impulso nocturno y dormir
              profundamente.
            </p>
          </div>
        </div>
      </div>

      <div className="mt-12 text-center bg-[#D4735E] text-white p-6 rounded-xl" data-id="element-60">
        <p className="font-medium text-lg" data-id="element-61">
          No te prometo perfección. Te doy una estructura para días reales.
        </p>
      </div>
    </Section>;
}